import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
import { setCookie, getCookie } from '../utils/cookie_utils.js'
import yaml from 'js-yaml';
import Fade from 'react-reveal/Fade';
import '../css/NavbarMenu.css';

class NavbarMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current_lang: this.props.lang, // en, zh, ja
      mobile_flag: false,
      menu_name: this.props.menu_name,
      custom_btn: [{
            title: {
                en: "Customized robots & automation solutions",
                zh: "查看更多客製化機器人及自動化方案",
                ja: "カスタムロボット及自動化ソリューション"
            },
            href_link: {
                main: "/SolutionPage",
                id: ""
            }
        }],
      section: [],
      item: []
    }

    this.open_nav = this.open_nav.bind(this)
    this.get_data = this.get_data.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ current_lang: nextProps.lang });
    }
    if (nextProps.menu_name !== this.state.menu_name) {
      this.setState({ menu_name: nextProps.menu_name }, () => this.get_data(this.state.menu_name));
    }
  }

  componentDidMount() {
    this.get_data(this.state.menu_name)
  }

  get_data(menu_name) {
    fetch(process.env.PUBLIC_URL + '/yaml/section_product.yaml')
    .then(response => response.text())
    .then(text => {
        console.log(text, menu_name)
      const parsed = yaml.load(text)[menu_name];
      console.log(parsed)
      this.setState({ section: parsed.section, item: parsed.item });
    });
  }

  general_switch_page(path, data) {
    if (path !== "/MainPage" || path !== "/") {
      setCookie("lang", this.state.current_lang)
      window.location.href = path + "?page=" + data
    }
    else {
      // pass
    }
  }

  open_nav() {
    this.setState({
      mobile_flag: !this.state.mobile_flag
    })
  }

  render() {
        return (
          <>
            <Fade duration="500" delay="200">
                <div className={"v2_nav_menu_section "+this.state.current_lang}>
                    <button className="v2_nav_menu_section_close_btn" onClick={() => this.props.close_nav()}>x</button>
                    {this.state.item.map((section, idx) => 
                        <>
                            <h2>{this.state.section[idx][this.state.current_lang]}</h2>
                            <div className="v2_nav_menu_section_section_holder">
                                {section.map((product) => 
                                    <div className={"v2_nav_menu_section_product"} onClick={() => this.general_switch_page(product.href_link.main, product.href_link.id)}>
                                        <div className="v2_nav_menu_section_product_img_holder"><img src={product.product_img} alt={product.product_title[this.state.current_lang]} /></div>
                                        <div className="v2_nav_menu_section_product_text_holder">
                                            {product.product_status[this.state.current_lang] !== "-" ? <p className={"v2_nav_menu_section_product_status "+(product.product_status.status === 1 ? "blue_color" : product.product_status.status === 2 ? "red_color" : "")}>{product.product_status[this.state.current_lang]}</p> : <></>}
                                            {/* <p className="v2_nav_menu_section_product_id">{product.product_id}</p> */}
                                            <p className="v2_nav_menu_section_product_name">{product.product_title[this.state.current_lang]}</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                    <div className="v2_nav_menu_section_custom">
                        {this.state.custom_btn.map((btn) => 
                            <div className="v2_nav_menu_section_custom_product">
                                <img src="image/robot_logo.svg" alt="Robot Logo" className="v2_nav_menu_section_custom_icon" />
                                <p className="v2_nav_menu_section_custom_btn" onClick={() => this.general_switch_page(btn.href_link.main, btn.href_link.id)}>{btn.title[this.state.current_lang]}</p>
                            </div>
                        )}
                    </div>
                </div>
                
            </Fade>

            {/* {this.state.mobile_flag ? 
            <Fade duration="1000" delay="200">
              <div className="v2_nav_menu_mobile_tab">
                {this.state.nav_menu_content.map((item) => 
                  <p>test</p>
                )}
              </div></Fade> : <></> } */}
            
          </>
        ) 
  }

}


export default NavbarMenu;
